import { render, staticRenderFns } from "./BvalReportsMenu.vue?vue&type=template&id=a1f34818&scoped=true&"
import script from "./BvalReportsMenu.vue?vue&type=script&lang=js&"
export * from "./BvalReportsMenu.vue?vue&type=script&lang=js&"
import style0 from "./BvalReportsMenu.vue?vue&type=style&index=0&id=a1f34818&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f34818",
  null
  
)

export default component.exports